import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import HomePage from "../pages/home/page";
import BusinessPage from "../pages/business/BusinessPage";
import OneMinuteSolarPage from "../pages/product/OneMinuteSolarPage";
import SpaqCoreProductPage from "../pages/product/SpaqCorePage";
import TechnologyPage from "../pages/technology/TechnologyPage";
import PartnersPage from "../pages/partners/PartnersPage";
import CasesIndexPage from "../pages/cases/CasesIndexPage";
import CaseDetailPage from "../pages/cases/CaseDetailPage";
import CompanyPage from "../pages/company/CompanyPage";
import NewsIndexPage from "../pages/news/NewsIndexPage";
import NewsDetailPage from "../pages/news/NewsDetailPage";
import ContactPage from "../pages/contact/ContactPage";
import PrivacyPage from "../pages/privacy/PrivacyPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/business",
    element: <BusinessPage />,
  },
  {
    path: "/products/1minute-solar",
    element: <OneMinuteSolarPage />,
  },
  {
    path: "/products/spaq-core",
    element: <SpaqCoreProductPage />,
  },
  {
    path: "/technology",
    element: <TechnologyPage />,
  },
  {
    path: "/partners",
    element: <PartnersPage />,
  },
  {
    path: "/cases",
    element: <CasesIndexPage />,
  },
  {
    path: "/cases/:slug",
    element: <CaseDetailPage />,
  },
  {
    path: "/company",
    element: <CompanyPage />,
  },
  {
    path: "/news",
    element: <NewsIndexPage />,
  },
  {
    path: "/news/:slug",
    element: <NewsDetailPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
